import { Shark, Utils } from "shark-mvc";

import ViewBase from "../ViewBase";

import templateContent from "./sample-request-list.html";

import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import { dateRangeFilterComponent } from "../../_shark_jaws/components/dateRangeFilter/dateRangeFilterComponent";
import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import followUpComponent from "../../components/followUp/followUpComponent";
import getMoreComponent from "../../components/getMore/getMoreComponent";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import sampleRequestManager from "../../controllers/sampleRequestManager";
import sampleRequestModalComponent from "../../components/sampleRequestModal/sampleRequestModalComponent";
import setSampleRequestLabCodesModalComponent from "../../components/setSampleRequestLabCodesModal/setSampleRequestLabCodesModalComponent";
import setSampleRequestShippingDataModalComponent from "../../components/setSampleRequestShippingDataModal/setSampleRequestShippingDataModalComponent";
import statusSmartFilterComponent from "../../components/statusSmartFilter/statusSmartFilterComponent";
import { userManager } from "../../_shark_jaws/managers/userManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class SampleRequestListView extends ViewBase {
	constructor () {
		super("sampleRequestListView");
		this.setTemplate(templateContent);
	}

	// addSampleRequest () {

	// }

	// addSampleRequestBtn_clickHandler () {
	// 	this.addSampleRequest();
	// }

	async beforeLoad () {
		liveSearchComponent.behavior = "database";
		followUpComponent.set("targetItem", null);

		if (!Shark.$store.agentList || Shark.$store.agentList.lenght === 0) {
			await userManager.getList();
		}
		this.refreshList();

		exportCSVComponent.set({
			savedFileBaseName: "Lista Richieste Campionatura",
			exportMap: {
				name: "Lista Richieste Campionatura",
				id: "sampleRequestFieldMap",
				fields: {
					__agentName: "Agente",
					contactName: "Contatto",
					__requestTypeLabel: "Tipo di Campionatura",
					__createdAtLabel: "Data Richiesta",
					__deliveryDateLabel: "Data Consegna/Spedizione",
					__statusLabel: "Status",
					__shipTypeLabel: "Tipo di consegna",
					"shippingData.courierName": "Corriere",
					"shippingData.trackingCode": "Tracking",
					__shippingCostLabel: "Costo Spedizione",
				},
			},
		});
	}

	getSampleRequestByGuid (guid) {
		const { sampleRequestList } = Shark.get();
		const currSampleRequest = Utils.safp(sampleRequestList, "guid", guid);

		return currSampleRequest;
	}

	init () {
		this.addComponents([agentFilterComponent, dateRangeFilterComponent, exportCSVComponent, followUpComponent, getMoreComponent, liveSearchComponent, mainNavComponent, sampleRequestModalComponent, setSampleRequestLabCodesModalComponent, setSampleRequestShippingDataModalComponent, statusSmartFilterComponent, refreshListButtonComponent, waitBoxComponent]);

		const filtersStatus = this.getFiltersStatus();
		const statusFilters = [
			{
				active: filtersStatus?.filters?.[0]?.active !== undefined ? filtersStatus.filters[0].active : true,
				cssClass: "sr-status-pending",
				label: "In attesa",
				status: 1,
				statusName: "Pending",
			},
			{
				active: filtersStatus?.filters?.[1]?.active !== undefined ? filtersStatus.filters[1].active : true,
				cssClass: "sr-status-preparing",
				label: "In preparazione",
				status: 2,
				statusName: "Preparing",
			},
			{
				active: filtersStatus?.filters?.[2]?.active !== undefined ? filtersStatus.filters[2].active : true,
				cssClass: "sr-status-ready-for-pickup",
				label: "Pronta per il ritiro",
				status: 3,
				statusName: "ReadyForPickup",
			},
			{
				active: filtersStatus?.filters?.[3]?.active !== undefined ? filtersStatus.filters[3].active : true,
				cssClass: "sr-status-ready-for-shipping",
				label: "Pronta per la spedizione",
				status: 4,
				statusName: "ReadyForShipping",
			},
			{
				active: filtersStatus?.filters?.[4]?.active !== undefined ? filtersStatus.filters[4].active : true,
				cssClass: "sr-status-shipped",
				label: "Spedita",
				status: 5,
				statusName: "Shipped",
			},
			{
				active: filtersStatus?.filters?.[5]?.active !== undefined ? filtersStatus.filters[5].active : true,
				cssClass: "sr-status-picked-up",
				label: "Ritirata",
				status: 6,
				statusName: "PickedUp",
			},
		];

		statusSmartFilterComponent.setFilters(statusFilters);

		getMoreComponent.views[this.className] = {
			currentPage: 0,
		};

		Shark.set({
			sampleRequestList: [],
			__sampleRequestListTotalShippingCost: 0,
		});
	}

	refreshList (range = null) {
		this.refreshSampleRequestList(range);
	}

	refreshSampleRequestList (range = null) {
		waitBoxComponent.open();

		let incrementalRequest = false;

		if (!range) {
			getMoreComponent.views[this.className] = {
				currentPage: 0,
			};
			range = getMoreComponent.getCurrentPageRangeForView(this.className);
		}
		else {
			incrementalRequest = true;
		}

		const { agentFilter, dateRangeFilter } = Shark.get();
		const filters = {};

		filters.statuses = statusSmartFilterComponent.getActiveStatuses();

		if (agentFilter.agentGuid !== "") {
			filters.agentGuid = agentFilter.agentGuid;
		}

		if (!dateRangeFilter.ignoreDateRange) {
			filters.dateFrom = dateRangeFilter.__from;
			filters.dateTo = dateRangeFilter.__to;
		}

		if (this.textFilters) {
			Object.assign(filters, this.textFilters);
		}

		return sampleRequestManager.getFilteredList({filters, range, incrementalRequest})
		.then(response => {
			exportCSVComponent.set({
				listToExport: response.data,
			});
			
			followUpComponent.set({
				sourceList: response.data,
			});
			
			waitBoxComponent.close();
			
			const sampleRequestListTotalShippingCost = response.data.reduce((total, item) => total + item?.shippingData?.cost || 0, 0);

			Shark.set({
				__sampleRequestListTotalShippingCost: Shark.$store.currencyFormatter.format(sampleRequestListTotalShippingCost),
			});

			Shark.render();
			return true;
		});
	}

	sampleRequestActionBtn_clickHandler (event, data) {
		const currSampleRequest = this.getSampleRequestByGuid(data.guid);

		if (currSampleRequest) {
			switch(data.action) {
				case "delete":
					// if (confirm("Sei sicuro di voler cancellare questa Scheda Informativa?\n\nSe prosegui non sarà possibile annullare!")) {
					// 	this.deleteSiteInfoSheet(currSampleRequest);
					// }
					break;
				case "setStatus": {
					const destStatus = parseInt(data.status);

					if (confirm(`Vuoi davvero riportare la Richiesta di Campionatura ${currSampleRequest.__requestTypeLabel} per il Contatto "${currSampleRequest.contactName}" allo Status precedente?`)) {
						const reason = prompt("Per favore indica un motivo per questa modifica");

						waitBoxComponent.open();

						sampleRequestManager.revertStatus(currSampleRequest, destStatus, reason || "")
						.then(() => {
							waitBoxComponent.close();
							this.refreshList();
						});
					}
					break;
				}
			}
		}
	}

	updateTextFilters (searchKey) {
		if (searchKey && searchKey !== "") {
			this.textFilters = {
				contactName: searchKey,
				searchKey,
			};
		}
		else {
			this.textFilters = null;
		}

		this.refreshList()
		.then(() => {
			if (searchKey !== "") {
				liveSearchComponent.setFocus();
			}
		});
	}
}

const sampleRequestListView = new SampleRequestListView();

Shark.registerView(sampleRequestListView);

export default sampleRequestListView;
